import FormUtils from '../utils/FormUtils';

let nameErrorMessage;

class Group {
  constructor(id = null, name, channelId, languages) {
    this.id = id;
    this.name = FormUtils.trimText(name);
    this.channelId = channelId;
    this.languages = languages;
  }
  validate() {
    const validators = {
      name: {
        isValid: () => {
          let isValidName = FormUtils.validateUrlName(this.name);
          if (isValidName) {
            nameErrorMessage = `Group Name${isValidName}`;
            return false;
          } else {
            return true;
          }
        },
        message: () => nameErrorMessage
      }
    };
    let errors = {};
    Object.keys(validators).forEach(key => {
      if (!validators[key].isValid(this[key])) {
        errors[key] = validators[key].message();
      }
    });
    return errors;
  }
}

export default Group;
